import React, {  } from 'react';
import { loginWith, sendSmsCode } from '../../apis/auth'
import { useNavigate } from 'react-router-dom';
import { ROUTER_DIAGRAMS, ROUTER_INDEX_PAGE } from '@/entry/route';
import logo from '@/assets/logo.png'
import SharedLogin from '@/components/SharedLogin';

interface LoginProps {
  visible: boolean;
  onClose: () => void;
}

const Login: React.FC<LoginProps> = ({ visible, onClose }) => {
  const navigate = useNavigate();
  const onSuccess = () => {
    navigate(ROUTER_INDEX_PAGE);
    window.location.reload();
  }
  return <SharedLogin visible={visible} onClose={onClose} logo={logo} loginApi={loginWith} sendSmsCodeApi={sendSmsCode} onSuccess={onSuccess} />
}

export default Login;